import React from 'react';
import PropTypes from 'prop-types';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography
} from '@material-ui/core';
import DialogButton from '../../../../Common/UI/Dialog/DialogButton';

const propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

const defaultProps = {

};

function ConfirmCriteriaDialog ({ open, onClose, onConfirm }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
        >
            <DialogTitle disableTypography>
                <Typography variant="h4">
                    Continue without search criteria?
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Typography
                    variant="subtitle1"
                >
                    Are you sure you wish to run a search without defining any suitability criteria rules?
                    <br /><br />
                    This can potentially return large numbers of results which aren't relevant to your specific requirements. If you require any help to set your search rules, please either contact the team or watch our SiteFinder video.
                </Typography>
            </DialogContent>
            <DialogActions>
                <DialogButton
                    onClick={onConfirm}
                    variant="contained"
                >
                    Continue
                </DialogButton>
                <DialogButton
                    onClick={onClose}
                    variant="outlined"
                >
                    Cancel
                </DialogButton>
            </DialogActions>
        </Dialog>
    );

}

ConfirmCriteriaDialog.propTypes = propTypes;
ConfirmCriteriaDialog.defaultProps = defaultProps;

export default ConfirmCriteriaDialog;